import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

class PLMAlarmDataService {
    static getGridData(data) {
        return RestEndPoint.callAzureFunction(
            APIUrlConstants.RetrieveScreenInfo,
            'POST',
            AppConstants.APP_BACKEND_HOST_KEY,
            data
        );
    }

    static updateData(data) {
        return RestEndPoint.callAzureFunction(
            APIUrlConstants.ExecuteScreenAction,
            'PUT',
            AppConstants.APP_BACKEND_HOST_KEY,
            data
        );
    }
}

export default PLMAlarmDataService
